export const translations = {
  de: {
    // Navigation
    nav_home: 'Home',
    nav_menu: 'Speisekarte',
    nav_order: 'Bestellung',
    nav_about: 'Über uns',
    nav_gallery: 'Galerie',
    nav_contact: 'Kontakt',
    
    // Header
    give_review: 'Google Bewertung abgeben',
    order_now: 'Jetzt bestellen',
    
    // Hero Section
    hero_title: 'Authentische türkische Küche in Berlin',
    hero_subtitle: 'Erleben Sie die Wärme und den Geschmack traditioneller türkischer Hausmannskost',
    view_menu: 'Speisekarte ansehen',
    
    // Menu Section
    menu_title: 'Unsere Speisekarte',
    menu_subtitle: 'Entdecken Sie unsere authentischen türkischen Gerichte',
    menu_note: 'Für Preise und Bestellungen nutzen Sie bitte unsere Partnerplattformen wie Wolt, Uber Eats und Lieferando.',
    
    // Categories
    cat_bestseller: 'Bestseller Menüs',
    cat_soups: 'Suppen (Çorbalar)',
    cat_mains: 'Hauptgerichte',
    cat_sides: 'Beilagen',
    cat_salads: 'Salate',
    cat_oven: 'Aus dem Steinofen',
    cat_desserts: 'Desserts',
    cat_drinks: 'Getränke',
    
    // Order Section
    order_title: 'Jetzt bestellen',
    order_subtitle: 'Wählen Sie Ihre bevorzugte Bestellmethode',
    delivery_title: 'Lieferung',
    delivery_subtitle: 'Bestellen Sie über unsere Partnerplattformen',
    pickup_title: 'Abholung',
    pickup_subtitle: 'Bestellen Sie zur Abholung',
    order_pickup: 'Zur Abholung bestellen',
    order_whatsapp: 'Per WhatsApp bestellen',
    
    // About Section
    about_title: 'Über uns',
    about_subtitle: 'Tradition trifft Geschmack',
    about_text_1: 'Willkommen bei Corbaci – Ihrem Zuhause für authentische türkische Hausmannskost in Berlin. Wir sind stolz darauf, traditionelle Rezepte zu servieren, die seit Generationen weitergegeben werden.',
    about_text_2: 'Unsere Köche bereiten jeden Tag frisch hausgemachte Gerichte zu, wobei sie nur die besten Zutaten verwenden. Von herzhaften Suppen bis hin zu köstlichen Hauptgerichten bringt jedes Gericht den wahren Geschmack der Türkei auf Ihren Tisch.',
    about_text_3: 'Besuchen Sie uns oder bestellen Sie nach Hause – genießen Sie die Wärme türkischer Gastfreundschaft und den unvergleichlichen Geschmack traditioneller Küche.',
    
    // Gallery Section
    gallery_title: 'Galerie',
    gallery_subtitle: 'Ein Blick auf unsere Gerichte und unser Ambiente',
    gallery_view_reviews: 'Kundenfotos auf Google ansehen',
    reviews_title: 'Bewertungen',
    reviews_subtitle: 'Das sagen unsere Gäste auf Google',
    rating_reviews_label: 'Bewertungen',
    rating_badge_text: 'Bewertung auf Google',
    extras_toggle: 'Beilagen & Extras',
    
    // Contact Section
    contact_title: 'Kontakt & Standort',
    contact_subtitle: 'Besuchen Sie uns oder nehmen Sie Kontakt auf',
    address: 'Adresse',
    phone: 'Telefon',
    hours: 'Öffnungszeiten',
    hours_value: 'Täglich: 07:00 – 00:00 (Lieferung: 11:00 – 23:30)',
    get_directions: 'Route planen',
    call_now: 'Jetzt anrufen',
    whatsapp_us: 'WhatsApp schreiben',
    
    // Footer
    footer_tagline: 'Authentische türkische Küche in Berlin',
    footer_follow: 'Folgen Sie uns',
    footer_rights: 'Alle Rechte vorbehalten',
  },
  
  en: {
    // Navigation
    nav_home: 'Home',
    nav_menu: 'Menu',
    nav_order: 'Order',
    nav_about: 'About',
    nav_gallery: 'Gallery',
    nav_contact: 'Contact',
    
    // Header
    give_review: 'Leave Google Review',
    order_now: 'Order Now',
    
    // Hero Section
    hero_title: 'Authentic Turkish Cuisine in Berlin',
    hero_subtitle: 'Experience the warmth and taste of traditional Turkish home-style cooking',
    view_menu: 'View Menu',
    
    // Menu Section
    menu_title: 'Our Menu',
    menu_subtitle: 'Discover our authentic Turkish dishes',
    menu_note: 'For prices and orders, please use our partner platforms like Wolt, Uber Eats, and Lieferando.',
    
    // Categories
    cat_bestseller: 'Bestseller Menus',
    cat_soups: 'Soups (Çorbalar)',
    cat_mains: 'Main Dishes',
    cat_sides: 'Side Dishes',
    cat_salads: 'Salads',
    cat_oven: 'From the Stone Oven',
    cat_desserts: 'Desserts',
    cat_drinks: 'Drinks',
    
    // Order Section
    order_title: 'Order Now',
    order_subtitle: 'Choose your preferred ordering method',
    delivery_title: 'Delivery',
    delivery_subtitle: 'Order through our partner platforms',
    pickup_title: 'Pickup',
    pickup_subtitle: 'Order for pickup',
    order_pickup: 'Order for Pickup',
    order_whatsapp: 'Order via WhatsApp',
    
    // About Section
    about_title: 'About Us',
    about_subtitle: 'Tradition meets taste',
    about_text_1: 'Welcome to Corbaci – your home for authentic Turkish home-style cuisine in Berlin. We take pride in serving traditional recipes that have been passed down through generations.',
    about_text_2: 'Our chefs prepare fresh homemade dishes every day, using only the finest ingredients. From hearty soups to delicious main courses, every dish brings the true taste of Turkey to your table.',
    about_text_3: 'Visit us or order for delivery – enjoy the warmth of Turkish hospitality and the unmatched flavor of traditional cuisine.',
    
    // Gallery Section
    gallery_title: 'Gallery',
    gallery_subtitle: 'A glimpse of our dishes and ambiance',
    gallery_view_reviews: 'View Customer Photos on Google',
    reviews_title: 'Reviews',
    reviews_subtitle: 'What our guests say on Google',
    rating_reviews_label: 'reviews',
    rating_badge_text: 'Rating on Google',
    extras_toggle: 'Sides & Extras',
    
    // Contact Section
    contact_title: 'Contact & Location',
    contact_subtitle: 'Visit us or get in touch',
    address: 'Address',
    phone: 'Phone',
    hours: 'Opening Hours',
    hours_value: 'Daily: 07:00 – 00:00 (Delivery: 11:00 – 23:30)',
    get_directions: 'Get Directions',
    call_now: 'Call Now',
    whatsapp_us: 'WhatsApp Us',
    
    // Footer
    footer_tagline: 'Authentic Turkish Cuisine in Berlin',
    footer_follow: 'Follow Us',
    footer_rights: 'All rights reserved',
  },
  
  tr: {
    // Navigation
    nav_home: 'Ana Sayfa',
    nav_menu: 'Menü',
    nav_order: 'Sipariş',
    nav_about: 'Hakkımızda',
    nav_gallery: 'Galeri',
    nav_contact: 'İletişim',
    
    // Header
    give_review: 'Google Değerlendirmesi Bırak',
    order_now: 'Şimdi Sipariş Ver',
    
    // Hero Section
    hero_title: 'Berlin\'de Otantik Türk Mutfağı',
    hero_subtitle: 'Geleneksel Türk ev yemeklerinin sıcaklığını ve lezzetini deneyimleyin',
    view_menu: 'Menüyü Görüntüle',
    
    // Menu Section
    menu_title: 'Menümüz',
    menu_subtitle: 'Otantik Türk yemeklerimizi keşfedin',
    menu_note: 'Fiyatlar ve siparişler için lütfen Wolt, Uber Eats ve Lieferando gibi ortak platformlarımızı kullanın.',
    
    // Categories
    cat_bestseller: 'Bestseller Menüler',
    cat_soups: 'Çorbalar',
    cat_mains: 'Ana Yemekler',
    cat_sides: 'Yan Ürünler',
    cat_salads: 'Salatalar',
    cat_oven: 'Fırından',
    cat_desserts: 'Tatlılar',
    cat_drinks: 'İçecekler',
    
    // Order Section
    order_title: 'Şimdi Sipariş Ver',
    order_subtitle: 'Tercih ettiğiniz sipariş yöntemini seçin',
    delivery_title: 'Teslimat',
    delivery_subtitle: 'Ortak platformlarımız üzerinden sipariş verin',
    pickup_title: 'Gel Al',
    pickup_subtitle: 'Gel al için sipariş ver',
    order_pickup: 'Gel Al Siparişi',
    order_whatsapp: 'WhatsApp ile Sipariş Ver',
    
    // About Section
    about_title: 'Hakkımızda',
    about_subtitle: 'Gelenek lezzetle buluşuyor',
    about_text_1: 'Corbaci\'ye hoş geldiniz – Berlin\'deki otantik Türk ev yemekleri eviniz. Nesillerden nesilere aktarılan geleneksel tarifleri sunmaktan gurur duyuyoruz.',
    about_text_2: 'Şeflerimiz her gün sadece en iyi malzemeleri kullanarak taze ev yapımı yemekler hazırlıyor. Doyurucu çorbalardan lezzetli ana yemeklere kadar her yemek Türkiye\'nin gerçek tadını masanıza getiriyor.',
    about_text_3: 'Bizi ziyaret edin veya eve sipariş verin – Türk misafirperverliğinin sıcaklığını ve geleneksel mutfağın eşsiz lezzetini yaşayın.',
    
    // Gallery Section
    gallery_title: 'Galeri',
    gallery_subtitle: 'Yemeklerimize ve atmosferimize bir bakış',
    gallery_view_reviews: 'Google\'da Müşteri Fotoğraflarını Görüntüle',
    reviews_title: 'Yorumlar',
    reviews_subtitle: 'Misafirlerimiz Google\'da böyle diyor',
    rating_reviews_label: 'yorum',
    rating_badge_text: 'Google puanı',
    extras_toggle: 'Garnitür & Ekstralar',
    
    // Contact Section
    contact_title: 'İletişim & Konum',
    contact_subtitle: 'Bizi ziyaret edin veya iletişime geçin',
    address: 'Adres',
    phone: 'Telefon',
    hours: 'Çalışma Saatleri',
    hours_value: 'Her gün: 07:00 – 00:00 (Teslimat: 11:00 – 23:30)',
    get_directions: 'Yol Tarifi Al',
    call_now: 'Şimdi Ara',
    whatsapp_us: 'WhatsApp',
    
    // Footer
    footer_tagline: 'Berlin\'de Otantik Türk Mutfağı',
    footer_follow: 'Takip Edin',
    footer_rights: 'Tüm hakları saklıdır',
  },
};
